import { z } from "zod";
import {
  AUDIENCE,
  LICENSE_CATEGORY,
  DOCUMENT,
} from "./consts";

export const addSchema = z.object({
  [AUDIENCE]: z.string().min(1, "This field is required"),
  [LICENSE_CATEGORY]: z.string().min(1, "This field is required"),
  [DOCUMENT]: z.instanceof(File, {message: "This field is required"})
});

export type AddHelpDocumentFormValues = z.infer<typeof addSchema>;
